import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { Maskot } from './Maskot';

export const SupportFormModal = React.memo(function SupportFormModal({ theme, onClose, source = 'anasayfa' }) {
  const isDark = theme === 'dark';
  const C = (k) => {
    const d = isDark, m = {
      surf: d ? '#141924' : '#FFFAF5',
      surf2: d ? 'rgba(255,255,255,0.04)' : 'rgba(139,92,246,0.04)',
      bord: d ? 'rgba(255,255,255,0.07)' : 'rgba(139,92,246,0.10)',
      bord2: d ? 'rgba(255,255,255,0.12)' : 'rgba(139,92,246,0.14)',
      txt: d ? '#ffffff' : '#1E1048',
      txt2: d ? 'rgba(255,255,255,0.5)' : '#4B3D7A',
      txt3: d ? 'rgba(255,255,255,0.25)' : '#9B8FBD',
      inp: d ? 'rgba(255,255,255,0.05)' : 'rgba(139,92,246,0.06)',
    };
    return m[k] || '';
  };
  const [form, setForm] = useState({ name: '', phone: '', school_interest: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const inp = {
    width: '100%', background: C('inp'), border: '1px solid ' + C('bord2'),
    borderRadius: 10, padding: '11px 14px', color: C('txt'), fontSize: 16,
    outline: 'none', fontFamily: 'DM Sans,sans-serif', boxSizing: 'border-box',
  };
  const lbl = { fontSize: 12, fontWeight: 600, color: C('txt2'), marginBottom: 5, display: 'block' };

  // Telefon formatlayıcı: +90 5XX XXX XX XX
  const formatPhone = (raw) => {
    let d = String(raw || '').replace(/\D/g, '');
    if (d.startsWith('90')) d = d.slice(2);
    else if (d.startsWith('0')) d = d.slice(1);
    d = d.slice(0, 10);
    let out = '+90';
    if (d.length > 0) out += ' ' + d.slice(0, 3);
    if (d.length > 3) out += ' ' + d.slice(3, 6);
    if (d.length > 6) out += ' ' + d.slice(6, 8);
    if (d.length > 8) out += ' ' + d.slice(8, 10);
    return out;
  };
  const onPhoneChange = (e) => setForm(f => ({ ...f, phone: formatPhone(e.target.value) }));
  const onPhoneFocus = () => { if (!form.phone) setForm(f => ({ ...f, phone: '+90 ' })); };
  const onPhoneBlur = () => {
    const v = (form.phone || '').trim();
    if (v === '+90' || v === '+90 ') setForm(f => ({ ...f, phone: '' }));
  };

  const submit = async () => {
    setError('');
    if (!form.name.trim() || !form.phone.trim() || !form.message.trim()) {
      setError('Lütfen ad soyad, telefon ve mesaj alanlarını doldurun.');
      return;
    }
    if (form.phone.replace(/\D/g, '').length < 10) {
      setError('Telefon numarası eksik. Örn: +90 532 213 84 87');
      return;
    }
    setSubmitting(true);
    try {
      const { error: insErr } = await supabase.from('support_requests').insert({
        name: form.name.trim(),
        phone: form.phone.trim(),
        school_interest: form.school_interest.trim() || null,
        message: form.message.trim(),
        source,
      });
      if (insErr) throw new Error(insErr.message);
      setDone(true);
    } catch (e) {
      setError(e.message || 'Talep gönderilemedi.');
    } finally {
      setSubmitting(false);
    }
  };

  const waLink = (() => {
    const text = encodeURIComponent(
      `Merhaba, OkulMap'ten yazıyorum.\nAd: ${form.name || ''}\nTel: ${form.phone || ''}` +
      (form.school_interest ? `\nOkul: ${form.school_interest}` : '') +
      `\nMesaj: ${form.message || ''}`
    );
    return `https://wa.me/905322138487?text=${text}`;
  })();

  if (done) {
    return (
      <div style={{ position: 'fixed', inset: 0, zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(8px)', padding: 16 }} onClick={onClose}>
        <div style={{ background: C('surf'), borderRadius: 20, padding: 32, width: 420, maxWidth: '100%', textAlign: 'center', border: '1px solid ' + C('bord2'), boxShadow: '0 24px 64px rgba(0,0,0,0.5)' }} onClick={e => e.stopPropagation()}>
          <Maskot type="mod" name="excited" size={80} style={{ margin: '0 auto 14px' }} />
          <div style={{ color: C('txt'), fontSize: 18, fontWeight: 800, marginBottom: 8, fontFamily: 'Syne,sans-serif' }}>Talebiniz alındı!</div>
          <div style={{ color: C('txt2'), fontSize: 13, lineHeight: 1.6, marginBottom: 18 }}>
            En kısa sürede size dönüş yapacağız. Daha hızlı yanıt için WhatsApp'tan da gönderebilirsiniz.
          </div>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href={waLink} target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '11px 20px', borderRadius: 10, background: 'linear-gradient(135deg,#25D366,#128C7E)', color: '#fff', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>
              💬 WhatsApp'tan Da Gönder
            </a>
            <button onClick={onClose} style={{ padding: '11px 22px', borderRadius: 10, background: C('surf2'), border: '1px solid ' + C('bord'), color: C('txt'), fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'DM Sans,sans-serif' }}>
              Tamam
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(8px)', padding: 16 }} onClick={onClose}>
      <div style={{ background: C('surf'), borderRadius: 20, width: 460, maxWidth: '100%', maxHeight: '92vh', overflowY: 'auto', border: '1px solid ' + C('bord2'), boxShadow: '0 24px 64px rgba(0,0,0,0.5)' }} onClick={e => e.stopPropagation()}>
        <div style={{ padding: '22px 26px 8px', borderBottom: '1px solid ' + C('bord'), display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, background: C('surf'), zIndex: 1 }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 800, color: C('txt'), fontFamily: 'Syne,sans-serif' }}>Bize Ulaşın</div>
            <div style={{ fontSize: 12, color: C('txt2'), marginTop: 2 }}>Sorularınızı destek ekibimize iletin</div>
          </div>
          <button onClick={onClose} style={{ width: 32, height: 32, borderRadius: 8, background: C('surf2'), border: '1px solid ' + C('bord'), color: C('txt2'), cursor: 'pointer', fontSize: 16, lineHeight: 1 }}>✕</button>
        </div>
        <div style={{ padding: '20px 26px 26px' }}>
          <div style={{ marginBottom: 14 }}>
            <label style={lbl}>Ad Soyad <span style={{ color: '#FF6B8A' }}>*</span></label>
            <input style={inp} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Adınız ve soyadınız" maxLength={120} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={lbl}>Telefon <span style={{ color: '#FF6B8A' }}>*</span></label>
            <input style={inp} type="tel" value={form.phone} onChange={onPhoneChange} onFocus={onPhoneFocus} onBlur={onPhoneBlur} placeholder="+90 532 213 84 87" maxLength={20} inputMode="tel" autoComplete="tel" />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={lbl}>İlgilendiğiniz Okul</label>
            <input style={inp} value={form.school_interest} onChange={e => setForm(f => ({ ...f, school_interest: e.target.value }))} placeholder="Opsiyonel — okul/kurum adı" maxLength={160} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={lbl}>Mesajınız <span style={{ color: '#FF6B8A' }}>*</span></label>
            <textarea style={{ ...inp, minHeight: 110, resize: 'vertical', lineHeight: 1.5 }} value={form.message} onChange={e => setForm(f => ({ ...f, message: e.target.value }))} placeholder="Sorularınız, talepleriniz..." maxLength={2000} />
          </div>
          {error && (
            <div style={{ padding: '10px 12px', borderRadius: 10, background: 'rgba(255,107,138,0.1)', border: '1px solid rgba(255,107,138,0.3)', color: '#FF6B8A', fontSize: 12, marginBottom: 12 }}>
              ⚠️ {error}
            </div>
          )}
          <button onClick={submit} disabled={submitting} style={{ width: '100%', padding: '13px 18px', borderRadius: 12, background: submitting ? 'rgba(168,218,255,0.3)' : 'linear-gradient(135deg,#A8DAFF,#7BB8F0)', border: 'none', color: '#000', fontSize: 14, fontWeight: 700, cursor: submitting ? 'wait' : 'pointer', fontFamily: 'DM Sans,sans-serif' }}>
            {submitting ? 'Gönderiliyor...' : 'Gönder'}
          </button>
          <div style={{ marginTop: 12, fontSize: 11, color: C('txt3'), textAlign: 'center', lineHeight: 1.5 }}>
            Hızlı yanıt için <a href="https://wa.me/905322138487" target="_blank" rel="noopener noreferrer" style={{ color: '#A8DAFF', textDecoration: 'none' }}>WhatsApp 0532 213 84 87</a>
          </div>
        </div>
      </div>
    </div>
  );
});
